import Model from "../../classes/model/Model";
import User from "./User";
import qs from "qs";

/**
 * @property {int} id
 * @property {int} is_delete
 * @property {int} old_id
 * @property {int} company_id
 * @property {string} name
 * @property {string} content
 * @property {string} image
 * @property {int} is_archive
 * @property {int} is_show_site
 *
 * @property {int} created_by
 * @property {int} updated_by
 * @property {int} created_at
 * @property {int} updated_at
 *
 * @property {User} creator
 * @property {User} updater
 */
export default class Direction extends Model {

    relations() {
        return {
            creator: {class: User, many: false},
            updater: {class: User, many: false},
        };
    }

    static getList(filter = {}, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return Direction.getAxios().get(Direction.getUrl('direction/list'), {
            params: {
                page: page,
                'per-page': perPage,
                filter: filter,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let direction of response.data) {
                data.push(new Direction(direction));
            }
            return {data, headers: response.headers};
        });
    }

}
